import { createStore } from 'vuex'

export default createStore({
  state: {
    show: false
  },
  getters: {
  },
  mutations: {
    setShow(state, show){
      state.show = show
    },
  },
  actions: {
  },
  modules: {
  }
})
